<div
  class="med_alert-wrapper d-flex flex-column justify-content-center align-items-center w-100"
  (click)="$event.stopPropagation(); closeAlert()"
>
  <app-icon
    [ngClass]="{
      success: alertData.alertType == 'success',
      error: alertData.alertType == 'error',
      warning: alertData.alertType == 'warning',
      info: alertData.alertType == 'info',
    }"
    [icon]="alertData.icon ? alertData.icon : 'info'"
    class="med_alert-icon success"
  ></app-icon>
  <mat-dialog-content>
    <h2 class="xl-title text-center bold m-0">{{ alertData.title | titlecase }}</h2>
    @if (alertData.alertDescription?.length) {
      <span class="xl-body">{{ alertData.alertDescription }}</span>
    }
  </mat-dialog-content>
  @if (alertData.showActionBtn) {
    <mat-dialog-actions class="med_action-btns">
      @if (alertData.closeText) {
        <button class="med_cancel-btn" (click)="close()" mat-button>
          {{ alertData.closeText | titlecase }}
        </button>
      }
      <button class="med_ok-btn" mat-button cdkFocusInitial (click)="onActionClick()">
        {{ alertData.actionText | titlecase }}
      </button>
    </mat-dialog-actions>
  }
</div>
